document.addEventListener('DOMContentLoaded', () => setListenerOnProductGridItems({ forceInit: true }));
document.addEventListener('BoaCollectionPageEvents', () => setListenerOnProductGridItems({ forceInit: true }));
document.addEventListener('cart:updated', () => setListenerOnProductGridItems({ forceInit: false }));
document.addEventListener('CartDrawer:open', () => {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => setListenerOnProductGridItems({ forceInit: true }));
  });
});

function setListenerOnProductGridItems({ forceInit = false } = {}) {
  document.querySelectorAll('.product-grid .product-item-sizes-popup').forEach((popup) => {
    const sizesWrapEl = popup.querySelector('.product-item-sizes-wrap');
    if (!sizesWrapEl) return;

    const alreadyBound = popup.dataset.sizesPopupBound === 'true';

    if (!alreadyBound) {
      popup.dataset.sizesPopupBound = 'true';
      popup.addEventListener('click', handleScrollSizes);
      sizesWrapEl.addEventListener('scroll', () => updateArrowVisibility(popup, sizesWrapEl), {
        passive: true,
      });
      sizesWrapEl.addEventListener('scrollend', () => {
        sizesWrapEl.dataset.scrolling = 'false';
        updateArrowVisibility(popup, sizesWrapEl);
      });
      sizesWrapEl.addEventListener('transitionend', (event) => {
        if (event.propertyName !== 'transform') return;
        sizesWrapEl.dataset.scrolling = 'false';
        updateArrowVisibility(popup, sizesWrapEl);
      });
      initSizesPopup(popup);
      return;
    }

    // Avoid resetting scroll position on cart:updated reflows
    if (forceInit) {
      initSizesPopup(popup);
    } else {
      updateArrowVisibility(popup, sizesWrapEl);
    }
  });
}

function getSizeItems(sizesWrapEl) {
  return sizesWrapEl?.querySelectorAll(':scope > .size-item') ?? [];
}

function getItemHeight(sizesWrapEl) {
  const firstItem = getSizeItems(sizesWrapEl)[0];
  if (!firstItem) return 18;
  return firstItem.getBoundingClientRect().height || firstItem.offsetHeight || 18;
}

function usesNativeScroll(sizesWrapEl) {
  if (sizesWrapEl.dataset.scrollMode === 'native') return true;
  if (sizesWrapEl.dataset.scrollMode === 'transform') return false;

  const overflowY = window.getComputedStyle(sizesWrapEl).overflowY;
  const native = overflowY === 'auto' || overflowY === 'scroll';
  sizesWrapEl.dataset.scrollMode = native ? 'native' : 'transform';
  return native;
}

/**
 * Native (cart): the wrap itself is the scrollport.
 * Transform (collection/search): the popup clips content at max-height;
 * the wrap grows with all items, so measuring wrap.clientHeight is wrong.
 */
function getViewportHeight(sizesWrapEl) {
  if (usesNativeScroll(sizesWrapEl)) {
    return sizesWrapEl.clientHeight || parseFloat(window.getComputedStyle(sizesWrapEl).height) || 0;
  }

  const popup = sizesWrapEl.closest('.product-item-sizes-popup');
  if (popup) {
    if (popup.clientHeight > 0) return popup.clientHeight;

    const maxHeight = parseFloat(window.getComputedStyle(popup).maxHeight);
    if (!Number.isNaN(maxHeight) && maxHeight > 0) return maxHeight;
  }

  return 0;
}

function getVisibleItemCount(sizesWrapEl) {
  const itemHeight = getItemHeight(sizesWrapEl);
  const viewportHeight = getViewportHeight(sizesWrapEl);
  if (!itemHeight || !viewportHeight) return 0;
  return Math.max(1, Math.floor(viewportHeight / itemHeight));
}

function getMaxScrollIndex(sizesWrapEl) {
  const totalItems = getSizeItems(sizesWrapEl).length;
  const visibleCount = getVisibleItemCount(sizesWrapEl);
  if (!totalItems || !visibleCount) return 0;
  return Math.max(0, totalItems - visibleCount);
}

function getScrollIndex(sizesWrapEl) {
  const itemHeight = getItemHeight(sizesWrapEl);
  if (!itemHeight) return 0;

  if (usesNativeScroll(sizesWrapEl)) {
    return Math.round(sizesWrapEl.scrollTop / itemHeight);
  }

  const transform = sizesWrapEl.style.transform || '';
  const match = transform.match(/translateY\(-([\d.]+)px\)/);
  const pixels = match ? parseFloat(match[1]) : 0;
  return Math.round(pixels / itemHeight);
}

function getScrollStep(visibleCount) {
  if (visibleCount <= 1) return 1;
  return visibleCount - 1;
}

function setScrollIndex(sizesWrapEl, scrollIndex, { smooth = false } = {}) {
  const itemHeight = getItemHeight(sizesWrapEl);
  const target = scrollIndex * itemHeight;

  if (usesNativeScroll(sizesWrapEl)) {
    sizesWrapEl.style.transform = '';
    if (smooth) {
      sizesWrapEl.dataset.scrolling = 'true';
      sizesWrapEl.scrollTo({ top: target, behavior: 'smooth' });
      window.setTimeout(() => {
        sizesWrapEl.dataset.scrolling = 'false';
        const popup = sizesWrapEl.closest('.product-item-sizes-popup');
        if (popup) updateArrowVisibility(popup, sizesWrapEl);
      }, 350);
    } else {
      sizesWrapEl.scrollTop = target;
      sizesWrapEl.dataset.scrolling = 'false';
    }
    return;
  }

  if (smooth) {
    sizesWrapEl.dataset.scrolling = 'true';
    sizesWrapEl.style.transition = 'transform 0.3s ease';
  } else {
    sizesWrapEl.style.transition = 'none';
  }
  sizesWrapEl.style.transform = target ? `translateY(-${target}px)` : 'translateY(0)';

  if (smooth) {
    window.setTimeout(() => {
      sizesWrapEl.dataset.scrolling = 'false';
      const popup = sizesWrapEl.closest('.product-item-sizes-popup');
      if (popup) updateArrowVisibility(popup, sizesWrapEl);
    }, 350);
  }
}

function updateArrowVisibility(sizesPopupEl, sizesWrapEl) {
  const upBtn = sizesPopupEl.querySelector('.arrow-btn-up');
  const downBtn = sizesPopupEl.querySelector('.arrow-btn-down');

  if (usesNativeScroll(sizesWrapEl)) {
    const maxScrollTop = Math.max(0, sizesWrapEl.scrollHeight - sizesWrapEl.clientHeight);
    const scrollTop = sizesWrapEl.scrollTop;
    const atTop = scrollTop <= 1;
    const atBottom = maxScrollTop <= 1 || scrollTop >= maxScrollTop - 1;

    upBtn?.classList.toggle('hidden-arrow', atTop);
    downBtn?.classList.toggle('hidden-arrow', atBottom);
    return;
  }

  const scrollIndex = getScrollIndex(sizesWrapEl);
  const maxScroll = getMaxScrollIndex(sizesWrapEl);
  upBtn?.classList.toggle('hidden-arrow', scrollIndex <= 0);
  downBtn?.classList.toggle('hidden-arrow', maxScroll <= 0 || scrollIndex >= maxScroll);
}

function initSizesPopup(popup) {
  const sizesWrapEl = popup.querySelector('.product-item-sizes-wrap');
  if (!sizesWrapEl) return;

  // Re-detect scroll mode in case layout/CSS changed since first bind
  delete sizesWrapEl.dataset.scrollMode;
  setScrollIndex(sizesWrapEl, 0, { smooth: false });
  updateArrowVisibility(popup, sizesWrapEl);
}

function handleScrollSizes(e) {
  const arrowBtn = e.target.closest('.arrow-btn');
  if (!arrowBtn || arrowBtn.classList.contains('hidden-arrow')) {
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  const sizesPopupEl = arrowBtn.closest('.product-item-sizes-popup');
  const sizesWrapEl = sizesPopupEl?.querySelector('.product-item-sizes-wrap');
  if (!sizesWrapEl) {
    return;
  }

  if (sizesWrapEl.dataset.scrolling === 'true') {
    return;
  }

  const itemHeight = getItemHeight(sizesWrapEl);
  if (!itemHeight) {
    return;
  }

  const visibleCount = getVisibleItemCount(sizesWrapEl);
  const maxScroll = getMaxScrollIndex(sizesWrapEl);
  const scrollStep = getScrollStep(visibleCount);
  const isArrowUp = arrowBtn.classList.contains('arrow-btn-up');
  let scrollIndex = getScrollIndex(sizesWrapEl);

  if (isArrowUp) {
    if (scrollIndex <= 0) return;
    scrollIndex = Math.max(0, scrollIndex - scrollStep);
  } else {
    if (scrollIndex >= maxScroll) return;
    scrollIndex = Math.min(maxScroll, scrollIndex + scrollStep);
  }

  setScrollIndex(sizesWrapEl, scrollIndex, { smooth: true });
  updateArrowVisibility(sizesPopupEl, sizesWrapEl);
}
